const genericFormatter = {
  channelName(channelName) {
    return channelName;
  }
};

const slackFormatter = {
  channelName(channelName) {
    return `#${channelName}`;
  }
};

export default function serviceFormatter(app) {
  if (app === 'slack') {
    return slackFormatter;
  }

  return genericFormatter;
}



/** WEBPACK FOOTER **
 ** ./src/utils/clientFormatter.js
 **/